import { isEmpty } from 'lodash';
import {
  BILLING_CYCLE,
  billingCycleDependBasePlanTypeList,
  dependMeetingPlanTypeList,
  licenseDependBasePlanTypeList,
  PlanModelInfo,
  planTypes,
} from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';

const UsersLimit = { max: 99, min: 1 };

const notStandardKeysOfZCM = {
  [BILLING_CYCLE.QUARTERLY]: 'archiving_compliance_quarterly',
  [BILLING_CYCLE.TWO_YEARS]: 'archiving_compliance_two_year',
  [BILLING_CYCLE.THREE_YEARS]: 'archiving_compliance_three_year',
};

const standardKeysOfZCM = {
  [BILLING_CYCLE.ANNUAL]: 'archiving_compliance_yearly',
  [BILLING_CYCLE.MONTHLY]: 'archiving_compliance_monthly',
};

const ZCMPlanMap = { ...notStandardKeysOfZCM, ...standardKeysOfZCM };

export default (planMapJSON) => {
  const zcm = planMapJSON.zcm;
  if (isEmpty(zcm)) {
    return [];
  }
  const result = [];
  Object.keys(ZCMPlanMap).forEach((billingCycle) => {
    const currentPlan = zcm[ZCMPlanMap[billingCycle]];
    if (currentPlan) {
      const { plan_code, prices = [] } = currentPlan;
      const priceObj = prices.find((item) => item.start <= 1 && item.end >= 99);
      result.push({
        type: planTypes.ZCM,
        typeNameKey: 'billing.zcm.title',
        planNameKey: 'billing.zcm.title',
        billing_cycle: billingCycle,
        category: 'ZCM',
        parent_category: 'ZCM',
        cartInfo: getCartInfo(),
        amount: priceObj.price,
        plan_code,
        supportCoupon: true,
        dependBasePlanTypeList: dependMeetingPlanTypeList,
        billingCycleDependBasePlanTypeList,
        licenseDependBasePlanTypeList,
        ...UsersLimit,
        planModel: PlanModelInfo.license
      });
    }
  });
  return result;
};
